import {
  Button,
  CloseButton,
  Dialog,
  Heading,
  Portal,
  Text,
} from "@chakra-ui/react";

type Props = {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
};

const ExitDialog = ({ open, onClose, onConfirm }: Props): JSX.Element => (
  <Dialog.Root
    lazyMount
    open={open}
    onOpenChange={(e) => !e.open && onClose()}
    size="sm"
  >
    <Portal>
      <Dialog.Backdrop />
      <Dialog.Positioner>
        <Dialog.Content>
          <Dialog.Header borderBottom="1px solid #ebecef80" padding="4">
            <Dialog.Title>
              <Heading>¿Salir de la inducción?</Heading>
            </Dialog.Title>
          </Dialog.Header>
          <Dialog.CloseTrigger asChild>
            <CloseButton marginTop="1" />
          </Dialog.CloseTrigger>
          <Dialog.Body py={6}>
            <Text>
              No guardamos tu avance. Si sales, tendrás que empezar de nuevo.
            </Text>
          </Dialog.Body>
          <Dialog.Footer borderTop="1px solid #ebecef80">
            <Button variant="outline" onClick={onClose}>
              Seguir aquí
            </Button>
            <Button onClick={onConfirm}>Salir</Button>
          </Dialog.Footer>
        </Dialog.Content>
      </Dialog.Positioner>
    </Portal>
  </Dialog.Root>
);

export default ExitDialog;
